import React from 'react';
import axios from "axios";

class ModulePills extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            gtin: this.props.gtin,
            items: []
        };
        this.componentDidMount = this.componentDidMount.bind(this)
    }


    componentDidMount() {
        const path = __API__ + `/api/ui/${this.state.gtin}/moduleitem`;
        axios.get(path)
        .then(response => {
            return response.data;
        })
        .then(data => {
            this.setState({
                items: data
            })
        })
        .catch(error => {
            console.log(error);
        });
    }


    render() {
        return (
                this.state.items.map((moduleItem) => {
                    const key = moduleItem.id;
                    if (moduleItem.expired) {
                        return (<span key={key} title="außerhalb des Nachversorgungszeitraums"
                                      className="badge badge-pill badge-secondary">{moduleItem.moduleName}</span>);
                    }
                    if (!moduleItem.replenishmentActive) {
                        return (<span key={key} title={moduleItem.deactivationReason}
                                      className="badge badge-pill badge-warning">{moduleItem.moduleName}</span>);
                    }
                    return (<span key={key} title="Nachversorgung aktiv"
                                  className="badge badge-pill badge-success">{moduleItem.moduleName}</span>);
                })
        )
    }
}

export default ModulePills;






// WEBPACK FOOTER //
// ./src/admin/components/ModulePills.js